// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapper":"SearchComments_resultsWrapper__3zFSu"};